<template>
  <page-container @window-return="windowReturn">
    <search-bar :items="[
      { key: 'category_ids', label: 'Categories', type: 'categroup', show_simple: true },
      { key: 'part_no_search', label: 'Part Number', type: 'input', width: 400, show_simple: true, hide_advanced: true },
      { key: 'part_no_is_accurate', label: '精确', type: 'checkbox', show_simple: true, hide_advanced: true },
      { key: 'is_special', label: 'Special', type: 'select', state: 'is_special', width: 100 },
      { key: 'visibility', label: 'Visibility', type: 'select', state: 'visibility', width: 100 },
      { key: 'stock_qty', label: 'Stock Qty >=', type: 'input', width: 80, placeholder: '0' },
      { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'oper_id', label: 'Input', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'part_no_search', label: 'Part Number', type: 'multi', width: 260 },
      { key: 'description', label: 'Description', type: 'multi', width: 260 },
      { key: 'brand', label: 'Brand', type: 'multi', width: 160 },
      { key: 'class_id', label: 'Class', type: 'select', state: 'class', option_value: 'id', option_label: 'name', width: 260 },
      { key: 'mkt', label: 'Information', type: 'multi', width: 260 },
      { key: 'company', label: 'Company', type: 'multi', width: 260 },
      { key: 'oper_time', label: 'Time', type: 'timerange' },
      { key: 'remark', label: 'Remark', type: 'input', width: 120 },
      { key: 'in_cart', label: 'In Current Cart', type: 'checkbox' }
    ]" @search="search"/>

    <div class="card">
      <div flex>
        <div>
          <el-button round size="small" icon="el-icon-printer" @click="print(1, '/requirement-preview')">Print</el-button>
          <el-button round size="small" icon="el-icon-document">To Excel</el-button>
          <template v-if="lastCompany.id">
            <el-button @click="$open('/requirement-refer')" style="margin-left:10px;">Show offer to requirement</el-button>
            <el-button @click="openRequirementList(lastCompany.name)" style="font-weight:bold;color:#000;">{{ lastCompany.name }} Requirement List</el-button>
            <el-button @click="$open('/requirement-refer-detail', 1100)">Show Item Details</el-button>
          </template>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>

      <cate-table :columns="[
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'display_qty', title: 'Qty' },
        { key: 'price', title: 'Price' },
        { key: 'remark', title: 'Remark' }
      ]"
      :data="list"
      :loading="loading"
      show-detail
      show-cart
      @detail-click="$open(`/product/${arguments[0]}/details`)"
      @part-click="$open(`/product/${arguments[0]}/require`)"
      style="margin:10px 0;" />

      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
  </page-container>
</template>

<script>
import ListFunc from '@/mixins/ListFunc'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'requirement_list',
      lastCompany: {
        id: 0,
        name: ''
      }
    }
  },
  mounted () {
    this.fetchLastCompany()
  },
  methods: {
    fetchLastCompany () {
      this.$http.get('/dbapi/last_require_company').then(data => {
        if (data.list.length > 0) {
          this.lastCompany = data.list[0]
        }
      })
    },
    openRequirementList (company_name) {
      if (!!company_name) {
        this.search({
          company: company_name,
          lookback: 30
        })
        this.fetchLastCompany()
      }
      this.$open('/requirement-list')
    },
    windowReturn () {
      this.refresh()
      this.fetchLastCompany()
    }
  }
}
</script>
